import template from './adpHeaderTopBar.html';
import controller from './adpHeaderTopBar.controller';
import './adpHeaderTopBar.less';

let adpHeaderTopBarComponent = {
  restrict: 'E',
  bindings: {},
  transclude: {
    left: '?topBarLeft',
    right: '?topBarRight',
  },
  template,
  controller
};

export default adpHeaderTopBarComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpHeaderTopBar/adpHeaderTopBar.component.js